import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const PATH =
  'M50 100C77.999 100 100 77.998 100 49.9978C99.9957 22.002 77.999 0 50 0C22.001 0 0 22.002 0 50.0022C0 78.0023 22.001 100 50 100 M49.9396 57.732H24.931C23.6513 57.732 22.6172 56.6936 22.6172 55.4181V45.7572C22.6172 44.4774 23.6556 43.4432 24.931 43.4432H42.7956V14.814C42.7956 13.5342 43.834 12.5 45.1094 12.5H54.7699C56.0496 12.5 57.0837 13.5385 57.0837 14.814V50.5876C57.0837 54.5304 53.8866 57.732 49.9396 57.732ZZ'

const IconCountdown: FC<IconProps> = props => (
  <SvgIcon {...props} path={PATH} viewBox="0 0 100 100" />
)

export default IconCountdown
